<template>
	<div class="mapEchart-wrapper">

     <ul>
     	<div>图例：</div>
     	<li @click="isShow(0)"><p></p>猪养殖厂</li>
     	<li @click="isShow(1)"><p></p>牛养殖厂</li>
     	<li @click="isShow(2)"><p></p>羊养殖厂</li>
     	<li @click="isShow(3)"><p></p>鸡养殖厂</li>
     	<li @click="isShow(4)"><p></p>鱼养殖厂</li>
     </ul>
		  <div ref="mapEchart">
		  </div>
	</div>
</template>

<script>
  import {echartsMixin} from '../../../assets/js/common/mixin'
  import axios from 'axios';
  import img1 from '../../../assets/img/1.png';
  import img2 from '../../../assets/img/2.png';
  import img3 from '../../../assets/img/3.png';
  import img4 from '../../../assets/img/4.png';
  import img5 from '../../../assets/img/5.png';
  export default {
    name: 'mapechart',
    mixins: [echartsMixin],
    props: {
      aYieldData: {
        type: Object,
        default() {
          return {}
        }
      },
    },
    data(){
    	return {
    		markerData:[{
            	name: "猪养殖场",
            	check:false,
            	item:1,
                symbol: `image://${img1}`,
                coord:[117.166699,28.140744],
                value:10,
                itemStyle:{
                	color:"#54FC33",
                }
        	},
        	{
        		name: "牛养殖场",
        		item:2,
        		check:false,
                symbol: `image://${img2}`,
                coord:[117.063789,28.149917],
                value:15,
                itemStyle:{
                	color:"#16E6FF",
                }
        	},
        	{
        		name: "羊养殖场",
        		item:3,
        		check:false,
                symbol: `image://${img3}`,
                coord:[116.85682,28.37797],
                value:16,
                itemStyle:{
                	color:"#F7E22E",
                }
        	},
        	{
        		name: "鸡养殖场",
        		item:4,
        		check:false,
                symbol: `image://${img4}`,
                coord:[117.205553,28.505018],
                value:21,
                itemStyle:{
                	color:"#FFA13C",
                }
        	},
        	{
        		name: "鱼养殖场",
        		item:5,
        		check:false,
                symbol: `image://${img5}`,
                coord:[116.932708,28.123415],
                value:8,
                itemStyle:{
                	color:"#FF3020",
                }
        	}
        	],
        	listData:[],
    	}
    },
    watch: {
      markerData: {
        handler: function (val, oldVal) {
             this.initChart()
        },
        deep: true  //增加deep 观察对象的子对象变化
      }
    },

    mounted() {
      this.myChart = this.$echarts.init(this.$refs.mapEchart)
      this.initOption()
      this.initChart()
    },

    methods: {
      isShow(i){
         this.markerData[i].check = !this.markerData[i].check
         this.markerData.forEach((val,index)=>{
      	  	 if(val.check == true){
      	  	 	val.coord = []
      	  	 }else{
      	  	 	val.coord = this.listData[index]
      	  	 }
      	  })
      },
      initOption() {
      	  this.markerData.forEach((val,index)=>{
      	  	 this.listData.push(val.coord)
      	  })
          this.option = {
            title:{
            	text:'鹰潭市',
            	left:"48%",
            	top:'43%',
            	textStyle:{
            		color:'#FFB209',
            	}
            },
            tooltip: {
              trigger: 'item',
              backgroundColor:"#002624",
			  borderColor:'#009288',
			  borderWidth:1,
	          textStyle:{
						color:"#fff",
					},
              formatter: (params) => {
				if(params.componentType == "markPoint"){
                     return "<div style='text-align:left;padding:15px'>" + `养殖区域分布<br>
                	        ${params.name}：<span style="color:#FF8A22;font-weight:bold;text-algin:center">${params.value}</span>` + "</div>"
				}
              },
            },
            grid: {
              left: "50",
              right: "10",
              top: '35',
              bottom: "15",
              containLabel: false
            },
            series: [
              {
                data: [],
                name: '产量',
                type: 'map',
                map: 'yingtan',
                // roam: true,
                zoom: 1.0,
                label: {
                  normal: {
                    show: true,
                    fontSize:16,
										color:"#D0FFBC",
                  },
                  emphasis: {
                  	show: true,
                  }
                },
                itemStyle: {
                  normal: {
                    areaColor: '#154643',
                    borderColor: '#00C0C9',
                    borderWidth:1,
                  },
                  emphasis: {
                    areaColor: '#154643'
                  }
                },
                markPoint:{
                	symbolSize:40,
                	label:{
                		show:false,
                		color:"#000",
                	},
                	data:[]
                }
              }
            ],

          }

      },
      initChart() {
        //如果有新的配置项的变化 深度拷贝
//        if (Object.keys(this.aYieldData.option).length) {
//          this.option = extend(true, this.option, this.aYieldData.option)
//        }
        axios.get('static/json/360600.json')
          .then((res) => {
            this.$echarts.registerMap('yingtan', res.data)
            this.option.series[0].data = [{name:'贵溪市',value: 34},{name:'余江县',value:20},{name:'月湖区',value: 10}]
            this.option.series[0].markPoint.data = this.markerData
           this.myChart.setOption(this.option, true);
//      	 console.log(this.option.series[0].data)
          })
      },
      _resizeHanlder(){
       	this.myChart.resize()
       },
       _destroyHandler(){
       	if (this.myChart) {
       		this.myChart.dispose()
       	}
       }

    }
  }
</script>

<style lang="scss" scoped>

  .mapEchart-wrapper {
    width: 100%;
    height: calc(100% - 30px);
    position: relative;
    div{
    	height: 100%;
    	width: 100%;
    }
    ul{
    	font-size: 12px;
    	position:absolute;
    	right:24px;
    	bottom:24px;
    	z-index: 120;
    	li{
    		display: flex;
    		align-items: center;
    		cursor: pointer;
    		p{
    			width: 16px;
    			height: 3px;
    			margin-right: 6px;
    		}
    		&:nth-of-type(1)>p{
    			background: #54FC33;
    		}
    		&:nth-of-type(2)>p{
    			background: #16E6FF;
    		}
    		&:nth-of-type(3)>p{
    			background: #F7E22E;
    		}
    		&:nth-of-type(4)>p{
    			background: #FFA13C;
    		}
    		&:nth-of-type(5)>p{
    			background: #FF3020;
    		}
    	}
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/pollute/charts/areaDistribute.vue